var TECL_FAQ = {
    Initialise: function() {
        var activeSlug = $( ".faq__category--active" ).attr( "data-slug" );
        var pageSlug = window.location.hash;

        if ( activeSlug && pageSlug ) {
            if ( activeSlug.toUpperCase() != pageSlug.toUpperCase() ) {
                var attr = "[data-slug='" + pageSlug + "']";
                var cleanedAttr = attr.replace( /\#/gi, "" );
                var match = $( cleanedAttr );

                if ( match.length > 0 ) {
                    TECL_FAQ.ChangeSection( match );
                }
            }
        }

        $( ".faq__category" ).click( function( event ) {
            event.preventDefault();
            TECL_FAQ.ChangeSection( this );
        } );
    },
    ChangeSection: function( element ) {
        var clickedElement = $( element );
        var siblingElements = $( element ).parents( "ul" ).find( ".faq__category" );
        
        siblingElements.removeClass( "faq__category--active" );
        clickedElement.addClass( "faq__category--active" );
        window.location.hash = $( element ).attr( "data-slug" );

        $.get( {
            url: clickedElement.attr( "data-href" ),
            success: function( response ) {
                $( ".faq__content" ).html( response );
            }
        } );
    }
}